// src/components/layout/SubnavBar.jsx
"use client";

export default function SubnavBar({ children, className = "" }) {
  return (
    <div className={`sticky-subnav edge-viewport bar-translucent bar-no-border ${className}`.trim()}>
      <div className="container-app">{children}</div>
    </div>
  );
}
